export enum EmailTypeEnum {
  SELECTED_STUDENT = 1,
  ALL_STUDENT = 2,
  EMPTY = 3,
}
